import {ValueObject} from '@s-ui/domain'

import {UserAdEntity} from '../Entities/UserAdEntity.js'

export class ListUserAdValueObject extends ValueObject {
  #ads

  constructor({ads}) {
    super()
    this.#ads = ads
  }

  static create({ads}) {
    return new ListUserAdValueObject({ads})
  }

  static createFromApiResponse({ads}) {
    return ListUserAdValueObject.create({
      ads: ads.map(ad => UserAdEntity.createFromApiResponse(ad))
    })
  }

  toJSON() {
    return {
      ads: this.#ads.map(adEntity => adEntity.toJSON())
    }
  }
}
